import React from 'react';
import { format } from 'date-fns';
import { sr } from 'date-fns/locale';

const StatusBadge = ({ isArchived, isVisible }) => {
  if (isArchived) return <span className="px-2 py-1 text-xs font-medium bg-red-100 text-red-700 rounded-full">Arhiviran</span>;
  if (!isVisible) return <span className="px-2 py-1 text-xs font-medium bg-orange-100 text-orange-700 rounded-full">Skriven</span>;
  return <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full">Aktivan</span>;
};

const ListingTable = ({ listings, selectedId, onSelect, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
      </div>
    );
  }

  if (!listings?.length) {
    return (
      <div className="text-center py-16 text-gray-500">
        <p className="text-lg font-medium">Nema oglasa</p>
        <p className="text-sm mt-1">Pokušajte sa drugačijim filterima</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-gray-200 bg-gray-50">
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Naslov</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Prodavac</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Datum</th>
            <th className="text-left py-3 px-4 font-semibold text-gray-600">Status</th>
          </tr>
        </thead>
        <tbody>
          {listings?.map((listing) => (
            <tr
              key={listing?.id}
              onClick={() => onSelect(listing)}
              className={`border-b border-gray-100 cursor-pointer transition-colors ${
                selectedId === listing?.id ? 'bg-blue-50' : 'hover:bg-gray-50'
              }`}
            >
              <td className="py-3 px-4">
                <p className="font-medium text-gray-900 truncate max-w-xs">{listing?.wishTitle || listing?.voucherName || 'Bez naslova'}</p>
                <p className="text-xs text-gray-500 mt-0.5 truncate max-w-xs">{listing?.description?.substring(0, 60)}{listing?.description?.length > 60 ? '...' : ''}</p>
              </td>
              <td className="py-3 px-4">
                <p className="font-medium text-gray-800">{listing?.sellerName || 'N/A'}</p>
                <p className="text-xs text-gray-500">{listing?.sellerEmail || ''}</p>
              </td>
              <td className="py-3 px-4 text-gray-600 whitespace-nowrap">
                {listing?.createdAt ? format(new Date(listing?.createdAt), 'dd.MM.yyyy', { locale: sr }) : '-'}
              </td>
              <td className="py-3 px-4">
                <StatusBadge isArchived={listing?.isArchived} isVisible={listing?.isVisible} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListingTable;
